import React from 'react'

export default function Icon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="12" cy="12" r="12" fill="#FF4C00" />
      <path d="M13.5158 18H12.0438V8.4L9.61175 10.768V9.152L12.3158 6.528H13.5158V18Z" fill="white" />
    </svg>
  )
}
